// extracted by mini-css-extract-plugin
module.exports = {"flex":"Tab_flex__2OciD","active":"Tab_active__30Ehg","text":"Tab_text__f3gKE"};